import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { gridConfig } from '../../../config';
import {
    UPCOMING_CAMPAIGNS,
    SHORT_DELIVERY
} from '../../../config/constants';

import Campaign from './Campaign';
import CustomElement from './CustomElement';

import styles from './campaigns.scss';

/* eslint-disable react/jsx-no-bind */

export class Campaigns extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.gridCalculation = gridConfig.open.gridCalculation;
        this.bannerRatio = gridConfig.open.bannerRatio;
        this.filteredGrid = gridConfig.open.filteredGrid;
        this.extraHeightPercent = 0;
        this.closePopover = this.closePopover.bind(this);
    }

    render() {
        const {
            id,
            grid,
            campaigns,
            columnCount,
            width,
            filterTag,
            location,
            hiddenCampaign,
        } = this.props;

        if (!campaigns || !grid) {
            return null;
        }

        const { query } = location;

        const elements = grid[columnCount];
        const maxColumnHeight = this.getMaxElementHeight();
        let campaignIndex = 0; // only for upcoming campaings, banner position is not counted
        let customElementIndex = 0;

        return (
            <div
                style={{ paddingBottom: `${this.getGridHeight(columnCount, maxColumnHeight, width)}%` }}
                styleName="wrapper"
                id={ `campaigns-${id}` }
            >
                {elements.map((element, index) => {
                    const elementStyle = this.getCampaignStyles(element, columnCount, width);
                    const campaign = campaigns[element.ref];

                    return campaigns[element.ref] ? (
                        <Campaign
                            key={element.ref}
                            campaign={campaign}
                            isUpcoming={id === UPCOMING_CAMPAIGNS}
                            dimension={`${element.w}x${element.h}`}
                            campaignStyles={elementStyle}
                            columnCount={columnCount}
                            showDelivery={filterTag === SHORT_DELIVERY}
                            showPopover={!this.state.hidePopover && element.ref === query.event}
                            closePopover={this.closePopover}
                            position={`${++campaignIndex},${columnCount}`}
                        />
                    ) : (
                        <CustomElement
                            key={`${element.id}-${++customElementIndex}`}
                            element={element}
                            dimension={`${element.w}x${element.h}`}
                            elementStyles={elementStyle}
                            id={`${element.id}-${customElementIndex}`}
                            hiddenCampaign={customElementIndex === 1 && hiddenCampaign}
                            position={++index}
                        />
                    );
                })}
            </div>
        );
    }

    getCampaignStyles(block, columnCount, gridWidth) {
        if (columnCount === 1 && this.props.id !== UPCOMING_CAMPAIGNS) {
            const labelHeight = 100 / gridWidth * 60;
            const blockHeight = (this.gridCalculation[columnCount].column / this.bannerRatio.h[block.w]) + labelHeight;

            return {
                left: 0,
                marginTop: (blockHeight + this.gridCalculation[columnCount].gutter) * block.y + block.y * this.extraHeightPercent,
                width: 100,
                paddingTop: blockHeight
            };
        }

        return {
            left: block.x * this.gridCalculation[columnCount].column + block.x * this.gridCalculation[columnCount].gutter,
            marginTop: block.y * (this.gridCalculation[columnCount].column * this.bannerRatio.v[1] + this.gridCalculation[columnCount].gutter) + block.y * this.extraHeightPercent,
            width: this.gridCalculation[columnCount].column * this.bannerRatio.h[block.w],
            paddingTop: this.gridCalculation[columnCount].column * this.bannerRatio.v[block.h]
        };
    }


    getMaxElementHeight() {
        let maxHeight = 0;
        this.props.grid[this.props.columnCount].forEach(element => {
            const sum = element.y + element.h;
            maxHeight = Math.max(sum, maxHeight);
        });

        return maxHeight;
    }

    getGridHeight(columnCount, maxColumnHeight, width) {
        const labelHeight = 100 / width * 60;
        const extraHeight = (
            this.filteredGrid &&
            this.filteredGrid.extraHeight &&
            this.filteredGrid.extraHeight[this.props.filterTag]
        ) ? this.filteredGrid.extraHeight[this.props.filterTag] : 0;

        this.extraHeightPercent = extraHeight * 100 / width;
        const rowHeight = columnCount === 1 && this.props.id !== UPCOMING_CAMPAIGNS ?
            (this.gridCalculation[columnCount].column / this.bannerRatio.h['2']) + labelHeight :
            this.gridCalculation[columnCount].column * this.bannerRatio.v['1'];

        return maxColumnHeight * rowHeight + (maxColumnHeight - 1) * (this.gridCalculation[columnCount].gutter) + maxColumnHeight * this.extraHeightPercent;
    }

    componentWillMount() {
        this.gridCalculation = gridConfig[this.props.id].gridCalculation;
        this.bannerRatio = gridConfig[this.props.id].bannerRatio;
        this.filteredGrid = gridConfig[this.props.id].filteredGrid;
    }

    closePopover() {
        this.setState({
            hidePopover: true
        });
    }
}

Campaigns.propTypes = {
    columnCount: PropTypes.number.isRequired,
    campaigns: PropTypes.object.isRequired,
    hiddenCampaign: PropTypes.object,
    grid: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    width: PropTypes.number,
    filterTag: PropTypes.string,
    location: PropTypes.object
};

Campaigns.defaultProps = {
    filterTag: 'all'
};

export default CSSModules(Campaigns, styles, { allowMultiple: true });
